'use strict';


export default function($http, $window, $timeout) {
	'ngInject';

	var vm = this;

	vm.submitCode = function() {
		vm.isSubmitting = true;
		delete vm.error;
		$http.post('/api/code/', {
			code: vm.code,
		}).then(function success(response) {
			$window.location.href = '/incidents/';
		}, function error(response) {
			switch(response.data.result) {
				case 'NO_CODE':
					break;
				case 'INVALID_CODE':
					vm.error = vm.code + ' is not a valid code.';
					break;
				default:
					vm.error = 'An unexpected error has occurred.  Please try again shortly.'
			}
		}).finally(function() {
			vm.isSubmitting = false;
		});
	}
}
